import { render, staticRenderFns } from "./MenuItemSubtext.vue?vue&type=template&id=6a9294cd&scoped=true"
import script from "./MenuItemSubtext.vue?vue&type=script&lang=js"
export * from "./MenuItemSubtext.vue?vue&type=script&lang=js"
import style0 from "./MenuItemSubtext.vue?vue&type=style&index=0&id=6a9294cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9294cd",
  null
  
)

export default component.exports